export default "../../src/img/heart-solid.svg";